import type { ReactNode } from "react";

import { Box, Divider, ListItem } from "@luce/ui";

import { usePackageDetailContext } from "../package-detail-context";

interface PackageRelatedVisitsProps {
  onPress: () => void;
  children?: ReactNode;
}

export function PackageRelatedVisits({ onPress, children }: PackageRelatedVisitsProps) {
  const { isAdHoc } = usePackageDetailContext();

  if (isAdHoc) return null;

  return (
    <>
      <Divider />
      <Box className="gap-spacing-md p-spacing-lg flex flex-col">
        <ListItem onPress={onPress} divider={false} layout="flush">
          <ListItem.LeadingIcon name="MapPinArea" size={24} weight="fill" color="brand-primary" />
          <ListItem.Content>
            <ListItem.ContentTitle>Related Visit(s)</ListItem.ContentTitle>
          </ListItem.Content>
          <ListItem.TrailingIcon name="CaretRight" size={16} color="brand-primary" />
        </ListItem>
        {children}
      </Box>
    </>
  );
}
